/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { AsyncHashLinkObserver } from 'react-hash-link';
import { MDXProvider } from '@mdx-js/react';

import CodeBlock from './code';
import { Footer } from './footer';
import Header from './header';
import { Page, Body } from './layout';
import SEO from './seo';
import { ExternalLink } from '../components/link';
import GlobalStyles from '../styles/global';
import { analytics } from '../utils/analytics';

/**
 * Open links to external sources in a new tab.
 */
const PostLink = props =>
  props.href.indexOf('#') === 0 ? (
    <a {...props} />
  ) : (
    <ExternalLink {...props} />
  );

const components = {
  pre: props => <div {...props} />,
  code: props => <CodeBlock {...props} />,
  a: PostLink,
};

if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

const PostLayout = ({ children, location: { pathname } }) => {
  const {
    site: {
      siteMetadata: { title },
    },
    allMdx: { edges: posts },
  } = useStaticQuery(graphql`
    query PostLayoutSiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      allMdx {
        edges {
          node {
            frontmatter {
              path
              title
              summary
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    analytics.trackVisit();
  }, []);

  const post = posts.find(post => pathname === post.node.frontmatter.path);

  return (
    <MDXProvider {...{ components }}>
      {post && (
        <SEO
          title={post.node.frontmatter.title}
          description={post.node.frontmatter.summary}
        />
      )}
      <GlobalStyles />
      <AsyncHashLinkObserver />
      <Page>
        <Header secondary siteTitle={title} />
        <Body>
          <main>{children}</main>
        </Body>
        <Footer />
      </Page>
    </MDXProvider>
  );
};

PostLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PostLayout;
